export type bulkRegistrationProp = {
  Name: string;
  StudentId: string;
  SchoolId: string;
  Cid: string;
  DzongkhagId: string;
  Dob: string;
  Category: string;
  GradeId: string;
  EccdId: string;
  Email: string;
  Password: string;
  Gender: string;
  MobileNo: string;
};

export const BulkRegistartionTemplate = [
  "Name",
  "Gender",
  "Cid",
  "Dob",
  "MobileNo",
  "Email",
  "Category",
  "StudentId",
  "EccdId",
  "SchoolId",
  "GradeId",
  "DzongkhagId",
  "Password",
];
